import styled from '@emotion/styled';

const SmallText =styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 23px;
  color: var(--grey);
`

export default SmallText;